import request from '@/utils/request'

// 查询上传作品列表
export function listWorks(query) {
  return request({
    url: '/Works/works/list',
    method: 'get',
    params: query
  })
}

export function listWorkss() {
  return request({
    url: '/Works/works/lists',
    method: 'get',
  })
}
export function listWorksss(query) {
  return request({
    url: '/Works/works/listss',
    method: 'get',
    params: query
  }) 
}

export function listWorkssslu(query) {
  return request({
    url: '/Works/works/listluss',
    method: 'get',
    params: query
  }) 
}
// 查询上传作品详细
export function getWorks(id) {
  return request({
    url: '/Works/works/' + id,
    method: 'get'
  })
}

// 新增上传作品
export function addWorks(data) {
  return request({
    url: '/Works/works',
    method: 'post',
    data: data
  })
}

// 修改上传作品
export function updateWorks(data) {
  return request({
    url: '/Works/works',
    method: 'put',
    data: data
  })
}

// 删除上传作品
export function delWorks(id) {
  return request({
    url: '/Works/works/' + id,
    method: 'delete'
  })


}

//根据编号查询作品详情
export function getWorkDetail(workId) {
  return request({
    url: `/WorkDetail/${workId}`,
    method: 'get'
  });
}
